import { useState } from "react";
import { motion } from "framer-motion";
import { ArrowUpRight, Check } from "lucide-react";
import { SERVICES } from "../../data/content";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";

export default function Services() {
  const [active, setActive] = useState(null);
  return (
    <section id="services" data-testid="services-section" className="relative py-28 md:py-40 px-6 md:px-10 bg-card/20">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16">
          <div>
            <span className="font-mono-x text-primary text-xs tracking-[0.35em]">/ 02 — CAPABILITIES</span>
            <h2 className="mt-6 font-heading font-extrabold tracking-tighter text-4xl md:text-5xl">Every load. Every lane.</h2>
          </div>
          <p className="max-w-sm text-muted-foreground">Seven specialized service lines, one accountable network. Tap any card for details.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-5">
          {SERVICES.map((s, i) => {
            const Icon = s.icon;
            return (
              <motion.button
                key={s.id}
                data-testid={`service-card-${s.id}`}
                onClick={() => setActive(s)}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.6, delay: (i % 3) * 0.08 }}
                className={`group relative overflow-hidden rounded-2xl border border-border text-left min-h-[260px] ${s.span}`}
              >
                <img src={s.image} alt={s.title} className="absolute inset-0 w-full h-full object-cover opacity-30 group-hover:opacity-45 group-hover:scale-105 transition-all duration-700" />
                <div className="absolute inset-0 bg-gradient-to-t from-card via-card/70 to-transparent" />
                <div className="relative h-full p-7 flex flex-col justify-between">
                  <div className="flex items-center justify-between">
                    <div className="w-12 h-12 rounded-xl glass flex items-center justify-center text-primary"><Icon className="w-5 h-5" /></div>
                    <ArrowUpRight className="w-5 h-5 text-muted-foreground group-hover:text-primary group-hover:rotate-45 transition-all" />
                  </div>
                  <div>
                    <h3 className="font-heading font-bold text-2xl">{s.title}</h3>
                    <p className="mt-2 text-sm text-muted-foreground max-w-md">{s.short}</p>
                  </div>
                </div>
                <span className="absolute bottom-0 left-0 h-[2px] w-0 bg-primary group-hover:w-full transition-all duration-500" />
              </motion.button>
            );
          })}
        </div>
      </div>

      <Dialog open={!!active} onOpenChange={(o) => !o && setActive(null)}>
        <DialogContent data-testid="service-dialog" className="glass max-w-lg border-border">
          {active && (
            <>
              <DialogHeader>
                <DialogTitle className="font-heading text-3xl flex items-center gap-3">
                  <active.icon className="w-7 h-7 text-primary" /> {active.title}
                </DialogTitle>
              </DialogHeader>
              <img src={active.image} alt={active.title} className="w-full h-44 object-cover rounded-xl" />
              <p className="text-muted-foreground">{active.short}</p>
              <ul className="grid grid-cols-2 gap-3 mt-2">
                {active.features.map((f) => (
                  <li key={f} className="flex items-center gap-2 text-sm"><Check className="w-4 h-4 text-primary" /> {f}</li>
                ))}
              </ul>
            </>
          )}
        </DialogContent>
      </Dialog>
    </section>
  );
}
